import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from "components/CustomButtons/Button.js";
import history from '../../../../../../history';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { isEmpty } from "lodash";
import Simplert from 'react-simplert';
import { Confirm } from 'react-async-popup';
import { FcReuse } from 'react-icons/fc';
import Check from "@material-ui/icons/Check";
import { resetOrder } from '../../../../../store/actions';
import {
    Checkbox

} from "@material-ui/core";

import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    whiteColor,
    blackColor,
    infoColor,
    mlAuto,
    hexToRgb,
} from "../../../../../../assets/jss/material-kit-pro-react.js";

import { CgCheck } from "react-icons/cg";
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";


const useStyles = theme => ({
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        margin: "0",
        float: "right!important",
        display: "block",
    },
    closebuttonPopUp: {
        backgroundColor: "#FF2E2E", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
    confirmbuttonPopUp: {
        backgroundColor: "#7ea11d", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "13px 2px", cursor: "pointer"
    },
    contentArea: {
        paddingBottom: "20px",
        paddingTop: "10px",
    },

});


class OrderDetails extends Component {

    constructor(props) {
        super(props);

        // Store the previous pathname and search strings
        this.currentPathname = null;
        this.currentSearch = null;
    }

    state = {
        orderNumber: ''
    }


    componentDidMount() {


 

        //pervents the user from going back again 
        //history.listen((newLocation, action) => {
        //    if (action === "PUSH") {
        //        if (
        //            newLocation.pathname !== this.currentPathname ||
        //            newLocation.search !== this.currentSearch
        //        ) {
        //            this.currentPathname = newLocation.pathname;
        //            this.currentSearch = newLocation.search;

        //            history.push({
        //                pathname: newLocation.pathname,
        //                search: newLocation.search
        //            });
        //        }
        //    } else {
        //        history.go(1);
        //    }
        //});

        if (!isEmpty(this.props.orderSummaryResult)) {

            this.setState({ orderNumber: this.props.fpmccann_OrderNumber }, () => {
                this.props.resetOrder();
            });
        
        }
        else {
            //history.push("/landing-pagePortal")
            this.props.history.push("/landing-pagePortal");
        }


    }

    async sendConfirmationEmail() {
        try {

            //send across usr id

        }
        catch (e) {

        }
    }



    render() {


        return (
            <div style={{ padding: "0px 0px 150px 0px" }} >
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} style={{ padding: "0px 0px 15px 0px" }}>
                        <h2 style={{ borderBottom: "2px dashed grey" }}> Order Confirmation Details <CgCheck color='green' /> </h2>
                    </GridItem>


                    {!isEmpty(this.state.orderNumber) ?
                        <>
                            <GridItem xs={6} sm={3} md={3}>
                                <h4 >Order Number: </h4>
                            </GridItem>

                            <GridItem xs={6} sm={3} md={3}>
                                <h4 > <b>{this.state.orderNumber} </b> </h4>
                            </GridItem> </>
                        :
                        null}

                </GridContainer>
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {

        user: state.userReducer.user,
        orderSummaryResult: state.orderReducer.orderSummaryResult,
        fpmccann_OrderNumber: state.orderReducer.fpmccann_OrderNumber

    };
};

export default compose(withRouter,connect(mapStateToProps, {resetOrder}))(withStyles(useStyles)(OrderDetails));
